export default __webpack_public_path__ + "static/media/Asia_05.b55c02a7.png";